//@flow
import React from 'react'
import { Ticino } from './images/ticino.js'
import { Munich } from './images/munich.js'
import { Vienna } from './images/vienna.js'
import { Venice } from './images/venice.js'
import { Paris } from './images/paris.js'
import { Card } from '../Card'
import './styles.scss'

let icons = {}

function numberWithApostroph(x) {
  let num = x.toString()
  if(num.length > 4) {
    num = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  }
  return num;
}

export class Grid extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    icons = { 
      ticino: <Ticino fill={this.props.colorMode === 'dark' ? '#fff' : '#202346'} />,
      munich: <Munich fill={this.props.colorMode === 'dark' ? '#fff' : '#202346'} />,
      vienna: <Vienna fill={this.props.colorMode === 'dark' ? '#fff' : '#202346'} />,
      venice: <Venice fill={this.props.colorMode === 'dark' ? '#fff' : '#202346'} />,
      paris: <Paris fill={this.props.colorMode === 'dark' ? '#fff' : '#202346'} />
    }

    return <div className='grid'>
      {icons[this.props.module]}
      <h2>{this.props.title}</h2>
      <div className='four-column'>
        {this.props.data && this.props.data.map((vehicle, i) => {
          return (
              <>
              {vehicle.Verhältnis && (
              <Card
                title={'Mit dem '+vehicle.Verkehrsmittel}
                vehicle={vehicle.Verkehrsmittel}
                type={vehicle.Typ}
                drive={vehicle.Antrieb}
                passengers={vehicle.Passagiere}
                start={vehicle.Start}
                end={vehicle.Ziel}
                kg={vehicle.CO2/1000}
                percentage={vehicle.Verhältnis}
                km={vehicle.Strecke}
                duration={vehicle.Dauer}
                key={'case-'+i}
                colorMode={this.props.colorMode}
              />
              )}
              </>
            )})
        }
      </div>
    </div>
  }
}



             